import type { ElementType } from 'react';

import { lazy, Suspense } from 'react';

import LoadingScreen from '../components/loading-screen';

/**
 * Loadable
 */
const Loadable = (Component: ElementType) => (props: any) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// ----------------------------------------------------------------------

/**
 * Dashboard page
 */
export const DashboardPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.DashboardPage }))
  )
);

// ----------------------------------------------------------------------

/**
 * Clients pages
 */
export const ClientListPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.ClientListPage }))
  )
);

export const ClientNewPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.ClientNewPage }))
  )
);

export const ClientProfilePage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.ClientProfilePage }))
  )
);

export const ClientPlacementsPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({
      default: module.ClientPlacementsPage,
    }))
  )
);

// ----------------------------------------------------------------------

/**
 * Customers pages
 */
export const CustomerListPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.CustomerListPage }))
  )
);

export const CustomerNewPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.CustomerNewPage }))
  )
);
export const CustomerProfilePage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({
      default: module.CustomerProfilePage,
    }))
  )
);
export const CustomerPlacementsPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({
      default: module.CustomerPlacementsPage,
    }))
  )
);

// ----------------------------------------------------------------------

/**
 * Placements pages
 */
export const PlacementListPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.PlacementListPage }))
  )
);

export const PlacementNewPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.PlacementNewPage }))
  )
);

export const PlacementProfilePage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({
      default: module.PlacementProfilePage,
    }))
  )
);

export const EndPlacementPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.EndPlacementPage }))
  )
);

// ----------------------------------------------------------------------

/**
 * Foster families pages
 */
export const FosterFamilyListPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({
      default: module.FosterFamilyListPage,
    }))
  )
);

export const FosterFamilyNewPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({
      default: module.FosterFamilyNewPage,
    }))
  )
);

export const FosterFamilyProfilePage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({
      default: module.FosterFamilyProfilePage,
    }))
  )
);

export const FosterFamilyPlacementsPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({
      default: module.FosterFamilyPlacementsPage,
    }))
  )
);

// ----------------------------------------------------------------------

/**
 * User pages
 */
export const UserListPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.UserListPage }))
  )
);

export const UserNewPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.UserNewPage }))
  )
);
export const UserProfilePage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({ default: module.UserProfilePage }))
  )
);
export const ChangePasswordPage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({
      default: module.ChangePasswordPage,
    }))
  )
);

// ----------------------------------------------------------------------

/**
 * Current User Profile page
 */
export const CurrentUserProfilePage = Loadable(
  lazy(() =>
    import('../pages').then((module) => ({
      default: module.CurrentUserProfilePage,
    }))
  )
);

// ----------------------------------------------------------------------

/**
 * Other pages
 */
export const LoginPage = Loadable(lazy(() => import('../pages/LoginPage')));

export const SetPasswordPage = Loadable(
  lazy(() => import('../pages/SetPasswordPage'))
);

export const ForgotPasswordPage = Loadable(
  lazy(() => import('../pages/ForgotPasswordPage'))
);

export const Page404 = Loadable(lazy(() => import('../pages/Page404')));

export const ValidateShareDocumentPage = Loadable(
  lazy(() => import('../pages/ValidateShareDocumentPage'))
);

export const ValidateShareVaultFilePage = Loadable(
  lazy(() => import('../pages/ValidateShareVaultFilePage'))
);
// ----------------------------------------------------------------------
